"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _qrcode = _interopRequireDefault(require("qrcode.react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _accountNetSdk = require("account-net-sdk");
var _login = require("../../consts/login");
require("./style.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Index = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var bizType = props.bizType,
    _props$id = props.id,
    id = _props$id === void 0 ? 'gy_qrCode' : _props$id,
    _props$size = props.size,
    size = _props$size === void 0 ? 177 : _props$size,
    setQrCodeStatus = props.setQrCodeStatus;
  // 二维码对象
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    qrCode = _useState2[0],
    setQrCode = _useState2[1];
  // 是否刷新
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRefresh = _useState4[0],
    setIsRefresh = _useState4[1];
  var refs = (0, _react.useRef)(false);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      qrCode: qrCode
    };
  });
  /**
   * 二维码值回调
   * @param params
   */
  var callbackQrValue = function callbackQrValue(params) {
    setQrCode(params.qrCode);
  };
  /**
   * 二维码状态回调
   * @param params
   */
  var callbackQrState = function callbackQrState(params) {
    if (!refs.current) {
      return;
    }
    var qrState = params.qrState;
    var isRefresh = false;
    if (qrState !== _login.QRCODE_STATUS.success && qrState !== _login.QRCODE_STATUS.ok) {
      isRefresh = true;
    }
    setIsRefresh(isRefresh);
    setQrCodeStatus && setQrCodeStatus(qrState);
  };
  (0, _react.useEffect)(function () {
    refs.current = true;
    (0, _accountNetSdk.QrCode)(callbackQrValue, callbackQrState, {
      bizType: bizType
    });
    return function () {
      refs.current && (0, _accountNetSdk.QrCode)(function () {}, function () {}, {
        bizType: bizType,
        isClose: true
      });
      refs.current = false;
    };
  }, []);
  var handleRefresh = function handleRefresh() {
    (0, _accountNetSdk.QrCode)(callbackQrValue, callbackQrState, {
      bizType: bizType
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_qr_code_wrap"
  }, /*#__PURE__*/_react.default.createElement(_qrcode.default, {
    id: id,
    value: qrCode,
    size: size,
    fgColor: qrCode.length || isRefresh ? '#000' : '#fff'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_qr_code_timeout', {
      show_timeout: isRefresh
    }),
    onClick: handleRefresh,
    id: "text_qr_code"
  }, /*#__PURE__*/_react.default.createElement("div", null, "\u4E8C\u7EF4\u7801\u5931\u6548", /*#__PURE__*/_react.default.createElement("br", null), "\u8BF7\u70B9\u51FB\u5237\u65B0")));
});
var _default = Index;
exports.default = _default;